import FormAction from './form_action';

export default class SubmitFormAction extends FormAction {
	_actionUrl;
	_additionalParams;
	_formActionId;

	constructor(actionProps = {}) {
		super(actionProps);
	}

	get actionUrl() {
		return this._actionUrl;
	}

	set actionUrl(value) {
		this._actionUrl = value;
	}

	get additionalParams() {
		return this._additionalParams;
	}

	set additionalParams(value) {
		this._additionalParams = value;
	}

	get formActionId() {
		return this._formActionId;
	}

	set formActionId(value) {
		this._formActionId = value;
	}
}
